import React, { useEffect, useRef } from 'react';

const ScrollCaptor = (props) => {
  const scrollTargetRef = useRef(null);
  let isBottom = false;
  let isTop = false;
  let touchStart = 0;

  const { onBottomArrive, onBottomLeave, onTopArrive, onTopLeave } = props;

  const cancelScroll = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleEventDelta = (event, delta) => {
    const scrollTarget = scrollTargetRef.current;
    if (!scrollTarget) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollTarget;
    const isDeltaPositive = delta > 0;
    const availableScroll = scrollHeight - clientHeight - scrollTop;

    let shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom) {
      if (onBottomLeave) {
        onBottomLeave(event);
      }
      isBottom = false;
    }
    if (isDeltaPositive && isTop) {
      if (onTopLeave) {
        onTopLeave(event);
      }
      isTop = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom) {
        onBottomArrive(event);
      }
      scrollTarget.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop) {
        onTopArrive(event);
      }
      scrollTarget.scrollTop = 0;
      shouldCancelScroll = true;
      isTop = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  };

  const onWheel = (event) => {
    handleEventDelta(event, event.deltaY);
  };

  const onTouchStart = (event) => {
    // set touch start so we can calculate touchmove delta
    touchStart = event.changedTouches[0].clientY;
  };

  const onTouchMove = (event) => {
    const deltaY = touchStart - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  };

  const startListening = (el) => {
    // bail early if no element is available to attach to
    if (!el) {
      return;
    }

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('wheel', onWheel, false);
      el.addEventListener('touchstart', onTouchStart, false);
      el.addEventListener('touchmove', onTouchMove, false);
    }
  };

  const stopListening = (el) => {
    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('wheel', onWheel, false);
      el.removeEventListener('touchstart', onTouchStart, false);
      el.removeEventListener('touchmove', onTouchMove, false);
    }
  };

  useEffect(() => {
    const el = scrollTargetRef.current;
    startListening(el);

    return () => {
      stopListening(el);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <span ref={scrollTargetRef}>{props.children}</span>;
};

export default function ScrollCaptorSwitch({ isEnabled = true, ...props }) {
  return isEnabled ? <ScrollCaptor {...props} /> : props.children;
}
